module.exports = __webpack_public_path__ + "img/381.f9d374af.png";